var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('div',{staticClass:"balloon",attrs:{"role":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.closeNotice.apply(null, arguments)}}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"message"},[_vm._v("サンプル書式が"),_c('br'),_vm._v("ダウンロードできます。")])
}]

export { render, staticRenderFns }